import React from 'react'
import Link from 'gatsby-link'
import NewsletterSignup from '../components/landing/newslettersignup/newsletterSignup'
import mockupimage from "../images/landing/mockup.png";

const PartnerPage = () => (
<div className="container">
    <div className="row">
        <div className="col-1">&nbsp;</div>
        <div className="col-10">
            <h1>Broadcast on Curveball</h1>
            <h2>Want to stream your very own live fantasy, betting, or interactive sports show to all your fans?
            </h2>
            <div className="row">
             <div className="col-12">&nbsp;</div>
                <div className="col-5">
                    <h3>Get started by filling out the form. We'll be in touch as soon as we can.
                    </h3>
                </div>
                <div className="col-1">&nbsp;</div>
                <div className="col-6">
                    <div id="mc_embed_signup">
                        <form action="https://curveball.us18.list-manage.com/subscribe/post?u=7d1ea90d9ced77bd2fef87ce5&amp;id=31edcd8237" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" className="validate" target="_blank" noValidate>
                            <div id="mc_embed_signup_scroll">
                                <div className="mc-field-group">
                                    <label htmlFor="mce-EMAIL">Email Address </label>
                                    <input type="email" defaultValue=""  placeholder="you@email.com" name="EMAIL" className="required email" id="mce-EMAIL" required />
                                </div>
                                <div className="mc-field-group">
                                    <label htmlFor="mce-FNAME">First Name </label>
                                    <input type="text" defaultValue=""  placeholder="John" name="FNAME" className="" id="mce-FNAME" required />
                                </div>
                                <div className="mc-field-group">
                                    <label htmlFor="mce-LNAME">Last Name</label>
                                    <input type="text" defaultValue=""  placeholder="Doe" name="LNAME" className="" id="mce-LNAME" required />
                                </div>
                                <div id="mce-responses" className="clear">
                                    <div className="response" id="mce-error-response" style={{ display: '' }}></div>
                                    <div className="response" id="mce-success-response" style={{ display: '' }}></div>
                                </div>
                                <div style={{ position: 'absolute', left: '-5000px' }} aria-hidden="true"><input type="text" name="b_7d1ea90d9ced77bd2fef87ce5_31edcd8237" tabIndex="-1" defaultValue="" /></div>
                                <input type="submit" defaultValue="Subscribe" name="subscribe" id="mc-embedded-subscribe" className="btn btn-primary" />
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <div className="col-1">&nbsp;</div>
    </div>
</div>
)

export default PartnerPage



// WEBPACK FOOTER //
// ./src/pages/partners.js